import { Fragment } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  home,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  homeOutline,
  shuffle,
  shuffleOutline,
  swapHorizontal,
  swapHorizontalOutline,
  cloudUpload,
  cloudUploadOutline,
} from "ionicons/icons";
import NavBarItem from "./NavBarItem";
import { useMyDetails } from "../../hooks/useMyDetails";

import "./NavToolBar.css";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ContainerProps extends RouteComponentProps<any> { }

// eslint-disable-next-line react-refresh/only-export-components
const NavToolBar: React.FC<ContainerProps> = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { isParent, isStudent, isStaff } = useMyDetails();

  return (
    <Fragment>
      <NavBarItem
        path="/home"
        iconOn={shuffle}
        iconOff={shuffleOutline}
        title={"Covers"}
        label={"Covers"}
      />
      <NavBarItem
        path="/room"
        iconOn={swapHorizontal}
        iconOff={swapHorizontalOutline}
        title={"Rooms"}
        label={"Rooms"}
      />
      <NavBarItem
        path="/uploads"
        iconOn={cloudUpload}
        iconOff={cloudUploadOutline}
        title={"Uploads"}
        label={"Uploads"}
      />
    </Fragment>
  );
};

export default withRouter(NavToolBar);
